<template>
  <v-layout row wrap>
    <v-flex py-2 xs12>
      <div class="text-xs-center app-modal-title-icon">
        <v-icon large class="warning--text">{{ icon }}</v-icon>
      </div>
    </v-flex>
    <v-flex xs12 px-5 py-2>
      <slot />
    </v-flex>
  </v-layout>
</template>

<script>
import Toolbar from './Toolbar'

export default {
  components: {
    Toolbar,
  },
  props: {
    icon: {
      type: String,
      default: 'warning',
    },
    isLoading: Boolean,
    toolbarActions: {
      type: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
  },
  data: () => ({}),
}
</script>